import React from "react";
import { motion } from "framer-motion";
import * as analytics from "@/lib/analytics";

export default function LandingHero({ onCTA }) {
  return (
    <section
      className="relative overflow-hidden pt-16 sm:pt-14"
      style={{ background: "#121212" }}
    >
      {/* Full-width hero image */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <img
          src="/images/giveaway/shutterstock_2764734931.jpg"
          alt="קהילת MOM3NTUM"
          className="w-full block md:hidden"
        />
        <img
          src="/images/giveaway/Desktop.png"
          alt="קהילת MOM3NTUM"
          className="w-full hidden md:block"
        />
      </motion.div>

      <div className="max-w-4xl mx-auto px-6 text-center py-16 md:py-24">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="font-bold text-white mb-4 leading-tight"
          style={{ fontSize: "clamp(2.5rem, 5vw, 4.5rem)" }}
        >
          Momentum
          <br />
          <span style={{ color: "#D7FF37" }}>כרטיס הכניסה לעידן חדש</span>
          <br />
          <span style={{ color: "#D7FF37" }}>(במחיר עלות)</span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.35 }}
          className="text-xl md:text-2xl font-medium mb-8"
          style={{ color: "rgba(255,255,255,0.85)" }}
        >
          <p>הכרטיס בידיים שלך.</p>
          <p>במחיר המקורי.</p>
          <p>סוף סוף.</p>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="text-base md:text-lg mb-6 max-w-2xl mx-auto leading-relaxed"
          style={{ color: "#FFFFFF" }}
        >
          MOM3NTUM היא שכבת הגישה החדשה לעולם האירועים. אנחנו לא עוד אתר כרטיסים
          – אנחנו המפתח שלך להזדמנות מובטחת, שמורה מראש ומאובטחת, לרכישת כרטיסים
          במחיר ה-Face Value שלהם.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.55 }}
          className="text-sm md:text-base mb-10"
          style={{ color: "rgba(255,255,255,0.5)" }}
        >
          בלי ספסרים, בלי בוטים, בלי משחקים. רק גישה הוגנת למה שבאמת מרגש אותכם.
        </motion.p>

        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          whileHover={{ scale: 1.05, boxShadow: "0 0 30px rgba(215,255,55,0.3)" }}
          whileTap={{ scale: 0.97 }}
          onClick={() => { analytics.trackCTA("hero", { position: "hero" }); onCTA(); }}
          className="px-10 py-3 rounded-full font-bold text-lg cursor-pointer"
          style={{ background: "#D7FF37", color: "#121212" }}
        >
          אני רוצה גישה מובטחת
        </motion.button>
      </div>
    </section>
  );
}
